import React from "react";
// import Button from "../../components/singlecomponents/Button";
import "../../stylesheet/components/getstarted/StartLearningNowBanner.scss";
import { useTranslation } from "react-i18next";

const StartLearningNowBanner: React.FC = () => {
  const { t, ready } = useTranslation();

  return (
    <div className="container-fluid start-learning__wrapper px-0 d-flex justify-content-center position-relative">
      <div className="container start-learning__outer px-0">
        <div className="start-learning__info">
          <div className="z-index-3">
            <h2>{ready ? t("misc.watch-this-space") + "!" : ""}</h2>
            {/* <div className="d-flex justify-content-center">
              <Button name="Register"/>
              <Button bootstrapClass="ms-2" buttonWhite name="Login"/>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartLearningNowBanner;
